module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"res":{"def":"Итого","pay":"К оплате","refund":"Вернём"},"order":"Заказать","save":"Сохранить","disabled":{"title":"Изменение параметров недоступно","text":"Виртуальный сервер находится в процессе обработки.","note":"Дождитесь завершения обработки"}}}')
  delete Component.options._Ctor
}
